import { Card, Result } from 'antd';
import { Outlet } from 'react-router-dom';
import { isAdminOrFinance } from '@/domain/roles';
import { useSessionStore } from '@/store/session';

/**
 * 按角色遮挡整条路由。
 *
 * ⚠️ 这只是**界面上的遮挡**，不是权限。真正的把关在服务端（requireAdmin /
 * requireAdminOrFinance）—— 任何人直接打接口都会被 403 拦住。这里存在的意义有两个：
 * 不让人看到一个必然失败的页面，以及挡住「导航里没有、但手敲 URL 进来」的路径。
 */
function Denied({ title }: { title: string }) {
  return (
    <Card>
      <Result status="403" title={title} subTitle="请联系组织管理员。" />
    </Card>
  );
}

/** 管理员专属路由的外层（设置页）。 */
export function RequireAdmin() {
  const isAdmin = useSessionStore((s) => s.me?.roles.includes('admin') ?? false);
  if (!isAdmin) return <Denied title="需要管理员权限" />;
  return <Outlet />;
}

/**
 * 打款链路与成员名单的外层：打款申请 / 打款记录 / 成员。
 * 🔴 member 到此为止 —— 它只管把收款信息收上来，不碰钱，也看不到组织的人员构成。
 */
export function RequireAdminOrFinance() {
  const ok = useSessionStore((s) => isAdminOrFinance(s.me?.roles ?? []));
  if (!ok) return <Denied title="需要管理员或财务权限" />;
  return <Outlet />;
}
